import React, { useState, useEffect } from "react";
import CaurisRoutes from "./CaurisRoutes";
import "./App.css";
import { BrowserRouter, useHistory } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { googleLogout, useGoogleLogin } from "@react-oauth/google";
import logo from "./images/cauris.png";
import ReactGA from "react-ga4";
import "bootstrap/dist/css/bootstrap.min.css";

export const App = () => {
  const history = useHistory();

  const [user, setUser] = useState();
  const [profile, setProfile] = useState(
    JSON.parse(localStorage.getItem("g_profile"))
  );
  ReactGA.initialize("G-Q07F029E8Z");
  const login = useGoogleLogin({
    onSuccess: (codeResponse) => setUser(codeResponse),
    onError: (error) => console.log("Login Failed:", error),
  });

  const [backgroundColor, setBackgroundColor] = useState("white");

  useEffect(() => {
    document.body.style.backgroundColor = backgroundColor;
  }, [backgroundColor]);

  const handleSuccess = async (response) => {
    const token = response.credential;
    console.log("TOKEN", token);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_DOMAIN}/auth/google`,
        { token },
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      const data = res.data;

      localStorage.setItem("token", data.jwt);

      localStorage.setItem("g_profile", JSON.stringify(data.user));

      setUser(data.user);
      setProfile(data.user);
      console.log("data ", data.user);
    } catch (error) {
      if (error.response) {
        // Server responded with a status other than 2xx
        console.error("Error response:", error.response.data);
      } else if (error.request) {
        // Request was made but no response received
        console.error("No response received:", error.request);
      } else {
        // Something else happened while setting up the request
        console.error("Request error:", error.message);
      }
    }

    // const token = response.credential;
    // console.log("RESPONSE", response);
    // const res = await fetch(process.env.REACT_APP_API_DOMAIN + "/auth/google", {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify({ token }),
    // });
  };

  useEffect(() => {
    if (process.env.REACT_APP_BYPASS_AUTH === "True") {
      var test_user = {};
      test_user["name"] = "Test User";
      test_user["picture"] =
        "https://agent.caurisfinance.com/static/media/cauris.78ad1a78da611d1d9d1d.png";
      setProfile(test_user);
      localStorage.setItem("g_profile", JSON.stringify(test_user));
    }
    if (user && process.env.REACT_APP_BYPASS_AUTH != "True") {
      let token = localStorage.getItem("token");
      console.log("LOGIN", user);
      try {
        axios
          .post(
            process.env.REACT_APP_API_DOMAIN + "/login",
            {
              email: user.email,
              name: user.name,
              user_id: user.email,
              profile_photo: user.picture,
              org_id: "",
            },
            {
              headers: {
                authorization: `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            console.log("IS RIGHT?", user);
            localStorage.setItem("g_profile", JSON.stringify(user));
            setProfile(user);
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.error("Error processing message:", error);
      } finally {
      }

      // history.push("/");
    }
  }, [user, history]);

  const logOut = () => {
    googleLogout();
    setProfile(null);
  };

  const responseMessage = (response) => {
    setUser(response);
    console.log("USER DATA", response);
  };
  const errorMessage = (error) => {
    console.log(error);
  };

  return (
    // <BrowserRouter>
    //   <CaurisRoutes />
    // </BrowserRouter>
    <div>
      {profile ? (
        <div>
          <BrowserRouter>
            <CaurisRoutes />
          </BrowserRouter>
        </div>
      ) : (
        <div className="loginBox">
          <img src={logo} alt="" className="titleImage" />
          <h2>Credit Copilot</h2>
          <br />
          <div className="welcomeText">Welcome to the Credit Copilot.</div>
          <br />
          <div className="loginButton">
            <GoogleLogin
              clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ""}
              onSuccess={handleSuccess}
              onFailure={(error) => console.error(error)}
              cookiePolicy={"single_host_origin"}
            />
          </div>

          <p>&nbsp;</p>
        </div>
      )}
    </div>
  );
};

export default App;
